import { render } from "./inputScan.vue?vue&type=template&id=50c659bc&scoped=true"
import script from "./inputScan.vue?vue&type=script&lang=js"
export * from "./inputScan.vue?vue&type=script&lang=js"

import "./inputScan.vue?vue&type=style&index=0&id=50c659bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c659bc"]])

export default __exports__